import template from './benefitItem.html';
import controller from './benefitItemCtrl.js';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    benefitType: '<',
  },
};
